export default Object.freeze({
  Entity: 1,
  Process: 2,
  //CustomList:3
});
